<div class="flex flex-col h-screen bg-gray-50 overflow-hidden">
    <!-- Skip to content -->
    <a
        class="sr-only focus:not-sr-only focus:absolute focus:z-[100000] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-white focus:text-gray-900 focus:rounded-lg focus:shadow-lg focus:ring-2 focus:ring-green-500"
        href="#main-content">
        Aller au contenu principal
    </a>

    <!-- Navbar - full width top -->
    <app-navbar [sidebarCollapsed]="sidebarCollapsed()" (toggleSidebar)="onToggleSidebar()" />

    <!-- Content area: sidebar + main -->
    <div class="flex flex-1 overflow-hidden">
        <!-- Sidebar -->
        <app-sidebar [collapsed]="sidebarCollapsed()" (sidebarToggle)="sidebarCollapsed.set(!sidebarCollapsed())" />

        <!-- Page content + footer -->
        <main class="flex-1 flex flex-col overflow-y-auto" id="main-content">
            <div class="flex-1 p-6 lg:p-8">
                <router-outlet />
            </div>
            <app-footer />
        </main>
    </div>

    <app-confirm-host />

    <app-lock-overlay />
</div>
